import React from "react";
import { useUnifiedFilters } from "../../hooks/useUnifiedFilters";
import { ReminderView } from "../../types/reminderTypes";
import styles from "./TherapyTakenToggle.module.scss";

interface TherapyTakenToggleProps {
  selectedView: ReminderView;
  className?: string;
}

const TherapyTakenToggle: React.FC<TherapyTakenToggleProps> = ({
  selectedView,
  className = "",
}) => {
  const { filters, updateFilters } = useUnifiedFilters(selectedView);
  const currentValue = filters.therapyTaken || "all";

  const options = [
    { value: "all", label: "Sve" },
    { value: "taken", label: "Uzeto" },
    { value: "pending", label: "Na čekanju" },
  ] as const;

  const handleToggle = (value: "all" | "taken" | "pending") => {
    updateFilters({ therapyTaken: value });
  };

  return (
    <div className={`${styles.therapyTakenToggle} ${className}`}>
      <span className={styles.label}>Terapija:</span>
      <div className={styles.toggleGroup}>
        {options.map((option) => (
          <button
            key={option.value}
            className={`${styles.toggleButton} ${
              currentValue === option.value ? styles.active : ""
            }`}
            onClick={() => handleToggle(option.value)}
            type="button"
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TherapyTakenToggle;
